/* AUTAVEX — Крапля: доповнення чорної + сіра основа */
(function(){
var S=window.AV_KANT_SETS=window.AV_KANT_SETS||{};
var CANT={0:'02_chornyi',1:'03_svitlosiryi',2:'04_siryi',3:'01_chervonyi',4:'11_syniy',5:'12_temnosyniy',
 6:'08_khaki',7:'14_korychnevyi',8:'16_bezhevyi',9:'17_slonovakistka',10:'18_bordovyi',11:'09_fioletovyi',
 12:'13_rozovyi',13:'07_zelenyi',14:'05_zhovtyi',15:'06_oranzhevyi',16:'15_bilyi',17:'10_holubyi'};

/* Крапля чорна — добираємо шість кантів */
var t='AUTAVEX-osnova-chorna-sota-teal_kant-',U2='.jpg?v=1786210104';
S['2|0']=S['2|0']||{};
S['2|0'][4]=t+'11_syniy_d8b6e008-50d4-48d5-a262-978ae1922547'+U2;
S['2|0'][11]=t+'09_fioletovyi_5b0ebd28-fe24-42eb-b8ff-ce30722acf7d'+U2;
S['2|0'][13]=t+'07_zelenyi_1b084402-d1d1-4d69-9462-e5f9e3739bab'+U2;
S['2|0'][14]=t+'05_zhovtyi_dc4aedee-1566-4013-96ec-af0f730774eb'+U2;
S['2|0'][15]=t+'06_oranzhevyi_6f4e9822-4cba-4944-8b10-d067d855c88b'+U2;
S['2|0'][16]=t+'15_bilyi_a9844816-8c6c-4472-8f33-81d128fc1f9e'+U2;

/* Крапля сіра (графіт) — всі 18 */
var g='AUTAVEX-osnova-grafit-sota_kant-',V='.jpg?v=1786210724',o={};
for(var k in CANT)o[k]=g+CANT[k]+V;
S['2|1']=o;
})();
